var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111}.cls-2{fill:#00c569}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.5 2.5v20h-20A2.5 2.5 0 0 0 0 25a2.5 2.5 0 0 0 2.5 2.5h20v20A2.5 2.5 0 0 0 25 50a2.5 2.5 0 0 0 2.5-2.5v-45A2.5 2.5 0 0 0 25 0a2.5 2.5 0 0 0-2.5 2.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31,
    y: 22.5,
    width: 19,
    height: 5,
    rx: 2.5,
    ry: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon2);
export default __webpack_public_path__ + "static/media/plusIcon2.7bfc6fdc79aa670cd8aa55b911e433e5.svg";
export { ForwardRef as ReactComponent };